import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import React, { useEffect, useState, useMemo } from 'react';
import { HashRouter as Router } from 'react-router-dom';
import './dx-styles.scss';
import LoadPanel from 'devextreme-react/load-panel';
import { NavigationProvider } from './contexts/navigation';
import { AuthProvider, useAuth } from './contexts/auth';
import { useScreenSizeClass } from './utils/media-query';
import Content from './Content';
import UnauthenticatedContent from './UnauthenticatedContent';
import Cookies from 'js-cookie';
import { licenseKey } from './licensekey.ts';
import config from 'devextreme/core/config';

config({
    licenseKey
})

function App() {
    const { user, setUser, loading } = useAuth();

    useEffect(() => {
        const cookierUser = Cookies.get("vitogram_integrated_user");
        if (cookierUser) {
            setUser(JSON.parse(cookierUser));
        }
    }, []);

    if (loading) {
        return <LoadPanel visible={true} />;
    }

    if (user) {
            return <Content user={user} />;
    }

    return <UnauthenticatedContent />;
}

export default function Root() {
    const screenSizeClass = useScreenSizeClass();

    return (
        <Router>
            <AuthProvider>
                <NavigationProvider>
                    <div className={`app ${screenSizeClass}`}>
                        <App />
                    </div>
                </NavigationProvider>
            </AuthProvider>
        </Router>
    );
}
